export default function NewMsgNotify(props) {

  if (props.hide === true) return null;

  return <div style={{display:'flex', flexDirection: 'column', marginLeft: '2px'}} >
    <div className={"chat-badge " + (props.className)}>{props.label ? props.label : 0}</div>
  </div>
}
